// todo Create Jira improvement task for services team to structure the names like in the names.js file.
export var SponsorNames = function(sponsorNamesData) {
    var sponsorNames = {};

    // Constructor
    if (sponsorNamesData) {
        sponsorNames.default = sponsorNamesData.default;
        sponsorNames.local = sponsorNamesData.local;
        sponsorNames.nonLocal = sponsorNamesData.nonLocal;
        sponsorNames.local2 = sponsorNamesData.local2;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    sponsorNames.getAName = function() {
        var name;

        if (sponsorNames.default) {
            name = sponsorNames.default;
        } else if (sponsorNames.local) {
            name = sponsorNames.local;
        } else if (sponsorNames.local2) {
            name = sponsorNames.local2;
        } else if (sponsorNames.nonLocal) {
            name = sponsorNames.nonLocal;
        }

        return name;
    };
    
    sponsorNames.getFirstName = function(sponsorName) {
        return (sponsorName.split(' '))[0];
    };
    
    sponsorNames.getLastName = function(sponsorName) {
        var lastName = '';
        var names = sponsorName.split(' ');

        if (names.length > 1) {
            lastName = sponsorName.replace(names[0] + ' ', '');
        }

        return lastName;
    };

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return sponsorNames;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/sponsorNames.js
// module id = 38
// module chunks = 0